import React, { useState, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import {
  TextField,
  Button
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { DeliverableStatus, ProjectDeliverableStatus } from "../../constants/Status";
import { AcceptFileType, Action, Role } from "../../constants/Common";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateDeliverable, updateDeliverableStatus } from "../../api/casp/deliverable";
import { Spinner } from "reactstrap";
// import AttachFile from '@material-ui/icons/AttachFile';
import { DocumentModule, Modules } from "../../constants/Module";
import { deleteDocument, documentList, uploadFile } from "../../api/casp/document";
import Loader from "../Common/Loader";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
// import { makeStyles } from "@material-ui/core";
import DocumentFilePreviewModal from "../casp/common/DocumentFilePreviewModal";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { getUrl } from "../../helpers/file_helper";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import { AttachFile } from "@mui/icons-material";
import { getAllPortfolios } from "../../api/casp/portfolio";
import { useSelector } from "react-redux";
import SearchDropDownPaginationList from "../casp/common/SearchDropDownPaginationList";

const useStyles = makeStyles({
  blueIcon: {
    color: '#296ced',
    cursor: 'pointer'
  },
});

const EditDeliverableDrawer = ({
  isOpen,
  handleClose,
  selectedRow,
  refresh,
  isDisabled,
  action,
  // projectDetails,
  t
}) => {
  const [isLoading, setIsLoading] =
    useState(false);
  const [disabled, setDisabled] = useState(false);
  const [trigger, setTrigger] = useState(new Date())
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [documentId, setDocumentId] = useState();
  const [deliverableObject, setDeliverableObject] = useState({
    name: selectedRow?.name ?? "",
    // cost: selectedRow?.cost ?? "",
    // description: selectedRow?.description ?? "",
    // expectedOutput: selectedRow?.expectedOutput ?? "",
    // weight: selectedRow?.weight ?? "",
    startDate: selectedRow?.startDate ?? "",
    endDate: selectedRow?.endDate ?? "",
    portfolios: selectedRow?.portfolio ? {
      id: selectedRow?.portfolio?.id,
      label: selectedRow?.portfolio?.name,
      key: `${selectedRow?.portfolio?.id}|${selectedRow?.portfolio?.name}`
    } : {}
  });
  const [filePath, setFilePath] = useState('');
  const [fileName, setFileName] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [modal, setModal] = useState(false);
  const classes = useStyles();
  const [loadingDocument, setLoadingDocument] = useState(false);
  // const projectStartDate = dayjs(projectDetails.startDate).format("YYYY-MM-DD")
  const deliverableValidation = Yup.object().shape({
    name: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .matches(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/? ]*$/, t("Name should be in proper type"))
      .required(t("Please enter name")),
    // portfolios: Yup.object().required(t("Please select cohort")),
    // description: Yup.string()
    //   .max(2000, t("Description can not be greater than 2000 characters"))
    //   .strict(true)
    //   .trim(t('Must not include leading and trailing spaces'))
    //   .required(t("Please Enter description")),
    // expectedOutput: Yup.string()
    //   .strict(true)
    //   .trim(t('Must not include leading and trailing spaces'))
    //   .max(250, t("Too Long!"))
    //   .required(t("Please Enter expected output")),
    // cost: Yup.number()
    //   .min(1, t("cost cannot be 0 or negative"))
    //   .positive(t('Cost must be in proper format'))
    //   .max(projectDetails?.projectCost, `${t('Cost of Deliverable can not exceed the project cost')} ${projectDetails?.projectCost}`)
    //   .required(t("Please Enter cost"))
    //   .test(t('two decimal places'), t('Numbers can only have two decimal places'), (value) => {
    //     return value === null || (value && /^\d+(\.\d{0,2})?$/.test(String(value)));
    //   }),
    // weight: Yup.number()
    //   .integer(t('Weight must be in proper'))
    //   .positive()
    //   .min(0, t("Too Short!"))
    //   .max(100, t("Too Long!"))
    //   .required(t("Please Enter weight")),
    // startDate: Yup.date()
    //   .typeError(t("Given date is invalid type"))
    //   .required(t("Please Enter start date")),
    // // .min(projectStartDate, `${t('Start date cannot be less than project start date')} ${dayjs(projectDetails?.startDate).format('MM/DD/YYYY')}`)
    // // .max(projectDetails?.endDate, `${t('Start date cannot be greater than project end date')} ${dayjs(projectDetails?.endDate).format('MM/DD/YYYY')}`),
    // endDate: Yup.date()
    //   .typeError(t("Given date is invalid type"))
    //   .required(t("Please Enter end date"))
      // .max(projectDetails?.endDate, `${t('End date cannot be greater than project end date')} ${dayjs(projectDetails?.endDate).format('MM/DD/YYYY')}`)
      // .min(
      //   Yup.ref('startDate'),
      //   t("End date cannot be before Start date")
      // ),
    ...(action === Action.SUBMIT && {
      documents: Yup.array().min(1, t('Select at least one document'))
    })
  });

  const formik = useFormik({
    initialValues: {
      ...deliverableObject,
      ...(action === Action.SUBMIT && {
        documents: []
      })
    },
    validationSchema: deliverableValidation,
    validateOnMount: true,
    onSubmit: (values) => {
      handleUpdate();
    },
  });

  useEffect(() => {
    if (selectedRow && action !== Action.EDIT) {
      getDocumentList()
      if (
        ![DeliverableStatus.DRAFT, DeliverableStatus.REJECTED].includes(
          selectedRow.currentStatus
        ) ||
        isDisabled || action === Action.VIEW
      ) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow]);

  // const handleKeyDownWeight = (event) => {

  //   if (event.keyCode === 8 || event.keyCode === 13) {
  //     return;
  //   }

  //   const regex = /^[0-9]+$/;

  //   if (!regex.test(event.key)) {
  //     event.preventDefault();
  //   }
  // }


  const handleUpdate = async () => {
    try {
      let requiredPayload = {
        // ...formik.values,
        name: formik.values.name,
        // startDate: formik.values.startDate,
        // endDate: formik.values.endDate,
        // portfolioId: formik.values.portfolios.id
        // cost: parseFloat(formik.values.cost),
        // weight: parseInt(formik.values.weight),
        // projectId: parseInt(selectedRow.project.id),
      };

      setIsLoading(true);
      const response = await updateDeliverable(selectedRow.id, requiredPayload);
      if (response.statusCode === 200) {
        await refresh();
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
      setIsLoading(false);
      handleClose();
    } catch (err) {
      setIsLoading(false);
      toast.error(err.message);
    }
  };

  const handleFileUpload = async (file) => {
    try {
      const fileExtension = file ? `.${file.name.split('.').pop().toLowerCase()}` : '';
      if (file && !AcceptFileType.includes(fileExtension)) {
        file = null;
        return toast.error('Invalid file type')
      }
      if (file.size > (1024 * 1024 * 10)) {
        return toast.error('Payload content length greater than maximum allowed: 10 MB');
      }

      setLoadingDocument(true)
      const formData = new FormData();
      formData.append('files', file);
      formData.append('moduleId', selectedRow.id);
      formData.append('module', DocumentModule.DELIVERABLE);
      formData.append('projectId', selectedRow.project.id);
      const result = (await uploadFile(formData)).data.data;
      setSelectedFiles((prev) => [...prev, result]);
      formik.setFieldValue('documents', [...selectedFiles, result])
      setTrigger(new Date())
      getDocumentList()
      setLoadingDocument(false)
    } catch (error) {
      setLoadingDocument(false)
    }
  }

  const getDocumentList = async () => {
    try {
      let params = {
        projectId: selectedRow.project.id,
        filterFields: ['documentAssociations'],
        filterInputs: '',
        module: Modules.DELIVERABLE,
        moduleId: selectedRow.id
      };
      const documentData = await documentList(params)
      setSelectedFiles(documentData.data.data.data)
      formik.setFieldValue('documents', documentData.data.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  const handelDelete = async () => {
    try {
      setIsOpenSweetAlert(false)
      setLoadingDocument(true)
      const res = await deleteDocument(documentId)
      toast.success(res.data.message)
      getDocumentList()
      setLoadingDocument(false)
      setDocumentId()
    } catch (err) {
      setLoadingDocument(false)
      setDocumentId()
      toast.error(err.message)
    }
  }

  const deliverableSubmit = async () => {
    try {
      setIsLoading(true);
      const res = await updateDeliverableStatus({
        status: ProjectDeliverableStatus.APPROVED,
        projectId: parseInt(selectedRow.project.id),
        deliverableId: parseInt(selectedRow.deliverable.id)
      });
      if (res.statusCode === 200) {
        toast.success(res.data.message);
        refresh()
      } else {
        toast.error(res.message);
      }
      handleClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
    }
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={handleClose}
        className="projectListDrawer"
        PaperProps={{
          sx: { width: "580px" },
        }}
      >
        <form className="editMilestoneDrawer p-3">
          <h5>{action === Action.EDIT ? t("Edit Deliverable") : t("Deliverable")}</h5>
          <CloseIcon className="crossIcon" onClick={handleClose} />
          <div className="innerTbContent">
            <div className="row">
              {/* Name */}
              <div className="col-sm-12 mb-3">
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label={t("Name")}
                  name="name"
                  value={formik.values.name}
                  inputProps={{
                    readOnly: isLoading || disabled,
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                />
                {formik.touched.name && formik.errors.name && (
                  <span className="text-danger">{formik.errors.name}</span>
                )}
              </div>
              {/* Description */}
              {/* <div className="col-sm-12 mb-3">
                <TextField
                  fullWidth
                  className="form-control"
                  id="deliverable-title-input"
                  label={t("Description")}
                  name="description"
                  value={formik.values.description}
                  inputProps={{
                    readOnly: isLoading || disabled,
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  multiline
                  required
                  rows={2}
                />
                {formik.touched.description && formik.errors.description && (
                  <span className="text-danger">{formik.errors.description}</span>
                )}
              </div> */}
              {/* Expected output */}
              {/* <div className="col-sm-12 mb-3">
                <TextField
                  fullWidth
                  className="form-control"
                  id="deliverable-title-input"
                  label={t("Expected Output")}
                  name="expectedOutput"
                  value={formik.values.expectedOutput}
                  inputProps={{
                    readOnly: isLoading || disabled,
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  multiline
                  required
                  rows={3}
                />
                {formik.touched.expectedOutput && formik.errors.expectedOutput && (
                  <span className="text-danger">{formik.errors.expectedOutput}</span>
                )}
              </div> */}
              {/* <div className="col-sm-6 mb-2 plCurrency"> */}
              {/* Cost */}
              {/* <div className="col-sm-6 mb-3 plCurrency currency_small_font">
                <TextField
                  id="deliverable-cost"
                  variant="outlined"
                  // label='Deliverable Cost'
                  decimalPlaces={2}
                  value={formik.values.cost}
                  // size="small"
                  currencySymbol="SAR"
                  fullWidth
                  placeholder={t("Deliverable Cost")}
                  required
                  inputProps={{
                    readOnly: isLoading || disabled,
                  }}
                  onChange={(e, newValue) => {
                    formik.setFieldValue('cost', newValue === 0 ? '' : newValue, true)
                  }}
                  onBlur={() => {
                    formik.setFieldTouched('cost', true, true)
                  }}
                />
                {formik.touched.cost && formik.errors.cost && (
                  <span className="text-danger">{formik.errors.cost}</span>
                )}
              </div> */}
              {/* weight */}
              {/* <div className="col-sm-6 mb-3">
                <TextField
                  onWheel={(e) => e.target.blur()}
                  fullWidth
                  id="outlined-basic"
                  label={t("Weight")}
                  name="weight"
                  value={formik.values.weight}
                  inputProps={{
                    readOnly: isLoading || disabled,
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="number"
                  onKeyDown={handleKeyDownWeight}
                  required
                />
                {formik.touched.weight && formik.errors.weight && (
                  <span className="text-danger">{formik.errors.weight}</span>
                )}
              </div> */}
              {/* Start Date */}
              {/* <div className="col-sm-6 mb-3 plDatepicker"> */}
                {/* <FormControl fullWidth> */}
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    {deliverableObject.startDate && (
                      <DatePicker
                        label={t("Start Date") + " *"}
                        name="startDate"
                        format="MM/DD/YYYY"
                        value={
                          formik?.values?.startDate?.toString().trim()
                            ? dayjs(formik.values.startDate)
                            : null
                        }
                        on
                        slotProps={{
                          field: {
                            clearable: true, onBlur: (_) => {
                              if (!formik.touched?.startDate) {
                                formik.setFieldTouched("startDate", true, false);
                              }
                            }
                          },
                          onClear: () => {
                            formik.setFieldValue("startDate", '');
                          },
                        }}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "startDate",
                            e ? dayjs(e).format("YYYY-MM-DD") : ''
                          );
                          if (!formik.touched?.startDate) {
                            formik.setFieldTouched("startDate", true, false);
                          }
                        }}
                        readOnly={
                          isLoading || disabled

                        }
                        required
                      />
                    )}
                  </DemoContainer>
                </LocalizationProvider> */}
                {/* </FormControl> */}
                {/* {formik.touched.startDate &&
                  formik.errors.startDate && (
                    <span className="text-danger">
                      {formik.errors.startDate}
                    </span>
                  )}
              </div> */}
              {/* End Date */}
              {/* <div className="col-sm-6 mb-3 plDatepicker"> */}
                {/* <FormControl fullWidth> */}
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    {deliverableObject.endDate && (
                      <DatePicker
                        label={t("End Date") + " *"}
                        name="endDate"
                        format="MM/DD/YYYY"
                        value={
                          formik?.values?.endDate?.toString().trim()
                            ? dayjs(formik.values.endDate)
                            : null
                        }
                        slotProps={{
                          field: {
                            clearable: true, onBlur: (_) => {
                              if (!formik.touched?.endDate) {
                                formik.setFieldTouched("endDate", true, false);
                              }
                            }
                          },
                          onClear: () => {
                            formik.setFieldValue("endDate", '');
                          },
                        }}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "endDate",
                            e ? dayjs(e).format("YYYY-MM-DD") : ''
                          );
                          if (!formik.touched?.endDate) {
                            formik.setFieldTouched("endDate", true, false);
                          }
                        }}
                        readOnly={
                          isLoading || disabled
                        }
                        required
                      />
                    )}
                  </DemoContainer>
                </LocalizationProvider> */}
                {/* </FormControl> */}
                {/* {formik.touched.endDate &&
                  formik.errors.endDate && (
                    <span className="text-danger">
                      {formik.errors.endDate}
                    </span>
                  )}
              </div>
              <div className="mb-3 plSelectTypeField">
                <SearchDropDownPaginationList
                  label={t("Cohort") + " *"}
                  disabled={isLoading || disabled}
                  searchEnabled={false}
                  listCall={getAllPortfolios}
                  disableClearable={!formik.values.portfolios}
                  defaultValue={formik.values.portfolios ? formik.values.portfolios : undefined}
                  apiParams={{
                    order: "updatedAt",
                    direction: "desc",
                    ...(![
                      Role.PROJECT_MANAGER,
                      Role.EPMO_MANAGER,
                      Role.ROOT_ADMIN,
                      Role.VICE_PRESIDENT,
                      Role.PRESIDENT,
                      Role.PROGRAM_MANAGER,
                      Role.EPMO_OFFICER,
                    ].includes(loggedInUser?.role?.name) && {
                      filterFields: "portfolioUser",
                      filterInputs: loggedInUser.id,
                    }),
                  }}
                  emitItem={(newValue) => {
                    formik.setFieldTouched("portfolios", true, true);
                    formik.setFieldValue(
                      "portfolios",
                      newValue ? newValue : {}
                    );
                  }}
                  onBlur={() => {
                    if (!formik.touched?.portfolios) {
                      formik.setFieldTouched("portfolios", true, true);
                    }
                  }}
                />
                {formik.touched.portfolios && formik.errors.portfolios && (
                  <span className="text-danger">
                    {formik.errors.portfolios}
                  </span>
                )}
              </div> */}
              {selectedRow.currentStatus !== DeliverableStatus.DRAFT && (
                <>
                  <div className="col-sm-12">
                    {action !== Action.VIEW ? (
                      <div className="uploaded_file">
                        <div key={trigger} className="p-3 mx-2 d-flex align-items-center">
                          <AttachFile
                            className="attachment_button"
                            style={{ cursor: 'pointer' }}
                          />
                          <span className="mx-2">{t("Attach Documents")}</span>
                          <input
                            key={trigger}
                            type="file"
                            accept={AcceptFileType.toString()}
                            name="documents"
                            onChange={(e) => handleFileUpload(e.target.files[0])}
                            onBlur={() => {
                              if (!formik.touched?.documents) {
                                formik.setFieldTouched("documents", true, false);
                              }
                            }}
                            style={{
                              opacity: 0,
                              position: "absolute",
                              top: "0",
                              left: 0,
                              background: "red",
                              height: "100%",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </div>
                    ) : (selectedFiles?.length > 0 && (
                      <h5 className="mb-0">{t("Attach Documents") + ":"}</h5>
                    )
                    )}

                  </div>
                  <div className="mx-3">
                    {formik?.touched?.documents && formik?.errors?.documents && (
                      <span className="text-danger">{formik?.errors?.documents} </span>
                    )}
                  </div>
                  <div>
                    {loadingDocument && <Loader />}
                    {
                      !loadingDocument && selectedFiles?.length > 0 && selectedFiles.map((file, key) => (
                        <>
                          <div className='d-flex mt-1 justify-content-between' key={key}>
                            <span className='fw-semibold text-truncate'>{file?.name} </span>
                            <div className="actions">
                              <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                                setModal(true)
                                setFilePath(getUrl(file.storageLink))
                                setFileName(file.name)
                              }
                              } />

                              {action !== Action.VIEW && (
                                <DeleteOutlineOutlinedIcon
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    setDocumentId(file.id)
                                    setIsOpenSweetAlert(true)
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </>
                      ))
                    }
                  </div>
                </>
              )}
            </div>
          </div>
          {!disabled && action === Action.EDIT && (
            <div className="plsubmitButton justify-content-center">
              <Button
                onClick={handleUpdate}
                disabled={isLoading || !formik.isValid}
                className="btn addNew_ProjectBtn"
              >
                {isLoading && (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-1"
                  />
                )}
                {t("Save")}
              </Button>
            </div>
          )}
          {action === Action.SUBMIT && [DeliverableStatus.ONGOING, DeliverableStatus.CONFIRMATION_REJECTED].includes(
            selectedRow.currentStatus
          ) && (
              <div className="plsubmitButton justify-content-center mt-4">
                <Button
                  onClick={deliverableSubmit}
                  disabled={isLoading || !formik.isValid}
                  className="btn addNew_ProjectBtn"
                >
                  {isLoading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                  )}
                  {t("Submit")}
                </Button>
              </div>
            )}
        </form>
      </Drawer>
      {isOpenSweetAlert && (
        <SweetAlert
          title="Are you sure want to delete this document?"
          warning
          showCancel
          confirmButtonText="Yes, delete it!"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => handelDelete()}
          onCancel={() => {
            setIsOpenSweetAlert(false)
          }}>
        </SweetAlert>
      )}

      {modal && (
        <DocumentFilePreviewModal modal={modal} setModal={setModal} filePath={filePath} fileName={fileName} />
      )}
    </>
  );
};

export default withTranslation()(EditDeliverableDrawer);
